import React from "react";
import PropTypes from "prop-types";
import { styled } from "@mui/material/styles";
import Typography from "@mui/material/Typography";
import { PagingInfo } from "@elastic/react-search-ui";

import { useValidAsOfDate, formatValidDate } from "../searchui/validDateService";
import { HEADER_HEIGHT, DATA_BAR_HEIGHT, FILTERS_WIDTH, BODY_WIDTH } from "../styles/layoutSizes";

export { DATA_BAR_HEIGHT };

const Root = styled("div")(({ theme }) => ({
  position: "sticky",
  top: HEADER_HEIGHT,
  zIndex: 1099,
  display: "flex",
  alignItems: "center",
  justifyContent: "space-between",
  gap: theme.spacing(2),
  paddingInline: theme.spacing(1.5),
  height: DATA_BAR_HEIGHT,
  backgroundColor: theme.palette.background.paper,
  borderBottom: `1px solid ${theme.palette.divider}`,
  width: "100%",
  [theme.breakpoints.up("lg")]: {
    width: FILTERS_WIDTH + BODY_WIDTH,
  },
}));

const LeftLabel = styled(Typography)(({ theme }) => ({
  fontSize: "0.6875rem",
  fontWeight: 600,
  textTransform: "uppercase",
  letterSpacing: "0.04em",
  color: theme.palette.text.secondary,
  marginRight: theme.spacing(0.5),
}));

const Value = styled(Typography)({
  fontSize: "0.75rem",
  fontWeight: 500,
});

const Left = styled("div")({
  display: "flex",
  alignItems: "baseline",
  minWidth: 0,
});

const muiPagingInfoView = ({ start, end, searchTerm, totalResults }) => {
  const capped = totalResults >= 10000;
  const formatted = totalResults?.toLocaleString?.() ?? totalResults;
  return (
    <Typography variant="body2" color="text.secondary" sx={{ fontSize: "0.75rem" }}>
      Showing&nbsp;<strong>{start}–{end}</strong> of {capped && "over "}<strong>{formatted}</strong>
      {searchTerm && <> for <em>{searchTerm}</em></>}
    </Typography>
  );
};

function DataBar({ wasSearched, initialLoader }) {
  const liveDate = useValidAsOfDate();
  return (
    <Root>
      <Left>
        <LeftLabel component="span">Valid as of</LeftLabel>
        {liveDate && <Value component="span">{formatValidDate(liveDate)}</Value>}
      </Left>
      {!initialLoader && wasSearched && <PagingInfo view={muiPagingInfoView} />}
    </Root>
  );
}

DataBar.propTypes = {
  wasSearched: PropTypes.any,
  initialLoader: PropTypes.bool,
};

export default DataBar;
